export class LoadMeAction {
  static readonly type = '[Me] Get Action'

  constructor() { }
};